import { Grid, NavBar, Space } from "antd-mobile";
import { Drill, HardHat } from "lucide-react";
import "./MobileApp.css";
import { useNavigate } from "react-router";

const Item = ({ icon, title,path, navigate}) => (
  <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
    <Space
      className={"pressable"}
      direction={"vertical"}
      onClick={() => navigate(path)}
      align="center"
      style={{ width: 104, padding: 8 }}
    >
      <div
        style={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "var(--adm-color-border)",
          borderRadius: 8,
          width: 90,
          height: 90,
          color: "var(--adm-color-text-secondary)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
        }}
      >
        {icon}
      </div>
      <div
        style={{
          lineHeight: "18px",
          height: "36px",
          maxHeight: "36px",
          textAlign: "center",
          color: "var(--adm-color-text)",
          display: "-webkit-box",
          "-webkit-box-orient": "vertical",
          "-webkit-line-clamp": "2",
          overflow: "hidden",
        }}
      >
        {title}
      </div>
    </Space>
  </div>
);

const apps = [
  { path: "dpiDelivery", icon: <HardHat size={24} />, title: "Consegna DPI" },
  { path: "dpiReturn", icon: <HardHat size={24} />, title: "Restituzione DPI" },
  { path: "equipments", icon: <Drill size={24} />, title: "Attrezzature" },
];

export default function () {
  const navigate = useNavigate();
  return (
    <>
      <NavBar back={null} style={{ background: "white" }}>
        Gamma HSE
      </NavBar>
      <Grid columns={3} style={{ marginTop: 24, padding: 16 }} gap={64}>
        {apps.map((app, index) => (
          <Grid.Item key={index}>
            <Item icon={app.icon} title={app.title} path={app.path} navigate={navigate}/>
          </Grid.Item>
        ))}
      </Grid>
    </>
  );
}
